const initialState = {
  fetching: false,
};

const loadingReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCHING_START":
      return {
        ...state,
        fetching: true,
      };
    case "FETCHING_FINISH":
      return {
        ...state,
        fetching: false,
      };
    default:
      return state;
  }
};

export default loadingReducer;
